/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EvmSearchHandlerInfo = {
    ID: EvmSearchHandlerInfo.ID;
    SRLIST: Record<string, any>;
};

export namespace EvmSearchHandlerInfo {

    export enum ID {
        BLOCK = 'BLOCK',
        TRANSACTION = 'TRANSACTION',
        ADDRESS = 'ADDRESS',
        TOKEN = 'TOKEN',
        STORAGE = 'STORAGE',
        BTC_STAKING = 'BTC_STAKING',
        BATCH_TRX = 'BATCH_TRX',
    }


}

